import { User } from "firebase/auth";
import { createContext } from "react";

export const AuthContext = createContext<{
    authUser: User | null;
    authUserLoading: boolean;
    signIn: (email: string, password: string) => Promise<void>;
    signOut: () => Promise<void>;
    setAuthUser: (user: User) => void;
    refetchAuthUser: () => Promise<void>;
}>({
    authUser: null,
    authUserLoading: true,
    setAuthUser: (_user: User) => undefined,
    refetchAuthUser: async () => undefined,
    signIn: async (_email: string, _password: string) => undefined,
    signOut: async () => undefined,
});
